import React from 'react';
import PropTypes from 'prop-types';
import {getWidgetValues} from "sportinglife-react-common/widgets";
import YouTubeVideo from "../../../Common/components/YouTubeVideo";
import withErrorBoundary from "../../../Errors/components/withErrorBoundry";

const YoutubeVideoWidget = ({bodyVisible, widget}) => {
  const {video_id, placeholder, title} = getWidgetValues(widget, ["video_id", "placeholder", "title"]);
  return bodyVisible && <div className="news-article-body-video">
    <YouTubeVideo videoId={video_id} placeholderImage={placeholder}/>
    {title && title.trim() && <div className="photo-caption">{title}</div>}
  </div>
};

YoutubeVideoWidget.mapProps = (props) => ({
  bodyVisible: props.bodyVisible,
  widget: props.widget
})
YoutubeVideoWidget.propTypes = {
  bodyVisible: PropTypes.bool,
  widget: PropTypes.object
}

export default withErrorBoundary(YoutubeVideoWidget);



// WEBPACK FOOTER //
// ./modules/News/components/widgets/YouTubeVideo.widget.js